import React from 'react';

function BankAccounts() {
  const banks = [
    { name: 'Сбер', tariff: 'Старт', price: '0 ₽/мес', bonus: '2 месяца бесплатно', url: 'https://www.sberbank.ru/ru/legal' },
    { name: 'Точка', tariff: 'Лайт', price: '500 ₽/мес', bonus: 'Бесплатные платежи физлицам', url: 'https://tochka.com' },
    { name: 'Тинькофф', tariff: 'Простой', price: '490 ₽/мес', bonus: '3 месяца бесплатно', url: 'https://www.tinkoff.ru/business' },
    { name: 'ВТБ', tariff: 'На старте', price: '0 ₽/мес', bonus: 'Бесплатный выпуск бизнес-карты', url: 'https://www.vtb.ru/business' },
    { name: 'Альфа-Банк', tariff: 'Ноль', price: '0 ₽/мес', bonus: 'Бесплатные переводы юрлицам', url: 'https://alfabank.ru/sme' },
    { name: 'Модульбанк', tariff: 'Старт', price: '0 ₽/мес', bonus: 'Бесплатная бухгалтерия на 3 мес', url: 'https://modulbank.ru' },
    { name: 'ПСБ', tariff: 'Бизнес-старт', price: '0 ₽/мес', bonus: 'Бесплатное открытие счёта', url: 'https://www.psbank.ru/Business' },
    { name: 'Райффайзен', tariff: 'Базовый', price: '490 ₽/мес', bonus: 'Бесплатный ВЭД-контроль', url: 'https://www.raiffeisen.ru/business' },
    { name: 'Открытие', tariff: 'Первый', price: '0 ₽/мес', bonus: 'Бесплатные платежи внутри банка', url: 'https://www.open.ru/business' },
    { name: 'Делобанк', tariff: 'Старт', price: '0 ₽/мес', bonus: 'Бесплатная бизнес-карта', url: 'https://delo.ru' },
  ];

  return (
    <div>
      <h2>Bank Accounts (RKO)</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Choose a bank for opening a current account with bonuses for Khepri users
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Bank</th>
            <th style={{ padding: 8 }}>Tariff</th>
            <th style={{ padding: 8 }}>Price</th>
            <th style={{ padding: 8 }}>Bonus</th>
            <th style={{ padding: 8 }}>Link</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((b, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{b.name}</td>
              <td style={{ padding: 8, color: '#94A3B8' }}>{b.tariff}</td>
              <td style={{ padding: 8 }}>{b.price}</td>
              <td style={{ padding: 8, color: '#10B981' }}>{b.bonus}</td>
              <td style={{ padding: 8 }}>
                <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Open →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BankAccounts;